/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {TemplateFeatureGroup} from './TemplateFeatureGroup';
import {TemplateCases} from './TemplateCases';

export interface Template {
  id: number;
  header: string;
  syncUid?: string;
  comment?: string;
  templateGroupId?: number;
  templateGroupTree?: string[];
  enabled: boolean;
  deleted?: boolean;
  createdAt?: Date;
  groups?: TemplateFeatureGroup[];
  cases?: TemplateCases;
  documentInput?: any;
}
